import SimilarTitlesApi from '../api/SimilarTitlesApi';
import SimilarTitlesConstants from '../constants/SimilarTitlesConstants';
import composeGlobalSuccessMessaging from '../helpers/messaging/composeGlobalSuccessMessaging';

function addSimilarTitle(metadataId, similarMetadataId, postSuccess) {
  return {
    metadataId,
    similarMetadataId,
    postSuccess,
    types: [
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_REQUEST,
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_SUCCESS,
      SimilarTitlesConstants.ADD_SIMILAR_TITLES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      SimilarTitlesApi.addSimilarTitle(
        {
          metadataId,
          similarMetadataId,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      )
  };
}

function removeSimilarTitleSuccess(similarMetadataId) {
  const messageId = 'message_successful_remove_similar_title';

  return {
    messaging: composeGlobalSuccessMessaging(messageId),
    deletedEntities: [`ugc.similarTitles.${similarMetadataId}`]
  };
}

function removeSimilarTitle(metadataId, similarMetadataId) {
  return {
    metadataId,
    similarMetadataId,
    types: [
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_REQUEST,
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_SUCCESS,
      SimilarTitlesConstants.REMOVE_SIMILAR_TITLES_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) =>
      SimilarTitlesApi.removeSimilarTitle(
        {
          similarMetadataId,
          userId: state.getIn(['auth', 'currentUserId'])
        },
        client
      ),
    apiSuccess: () => removeSimilarTitleSuccess(similarMetadataId)
  };
}

export default {
  addSimilarTitle,
  removeSimilarTitle
};
